/**
 * Accordion JavaScript
 *
 * This file defines behaviors of
 * the Accordion block.
 */

import { tabs, setupAutoHeightAni } from '../../../components/util/tabs';

// set up tabs for accordions
tabs({
	name: 'accordion',
	// openFirstTab: true, // on load pre-expand first tab
	// oneAtATime: true, // force one tab open at a time
	selectors: {
		wrap: '.accordion',
		toggles: '.accordion__button',
		content: '.accordion__content',
	},
});

setupAutoHeightAni('.accordion__inside');
